import styled from "@emotion/styled";
import { Box, Button, Divider } from "@mui/material";
import { base, grayModern, primary } from "configs/colors";

export const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${base.White};
`;

export const LeftSection = styled(Box)<{ mdUpMatched: boolean }>(
  ({ mdUpMatched }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: mdUpMatched ? "50%" : "100%",
    background: mdUpMatched
      ? undefined
      : `linear-gradient(45deg, ${primary[950]} 0%, ${primary[700]} 100%)`,
  })
);

export const RightSection = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 50%;
  background: linear-gradient(45deg, ${primary[950]} 0%, ${primary[700]} 100%);
`;

export const ContentImage = styled.img`
  height: 100%;
  padding: 0px 0px 0px 2px;
`;

export const FormContainer = styled(Box)`
  background-color: ${base.White};
  border-radius: 8px;
  padding: 24px;
  max-width: 420px;
  width: 100%;
`;

export const AzureIcon = styled.img`
  width: 22px;
  height: 22px;
  background: ${base.White};
  border-radius: 50%;
  padding: 1px;
`;

export const ORContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ORButton = styled(Button)`
  border-radius: 8px;
  margin: 24px 16px;
  width: 40%;
  pointer-events: none;
  border-color: ${grayModern[100]};
`;

export const ORDivider = styled(Divider)`
  width: 30%;
  border-color: ${grayModern[100]};
`;
